import { createStore } from "vuex";

export default createStore({
  state: {
    designCards: [
      {
        id: 1,
        group: "Kitchen",
        style: "Minimalism",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/fs/907d78138216073.6218d6d342d13.jpg",
        text: "A sleek minimalist kitchen designed for functionality and harmony.",
        link: "#",
        description: `This minimalist kitchen features clean lines, natural light, and a neutral palette to create a sense of calm. Open shelving and streamlined cabinetry maximize storage without clutter.
          <br /><br />
          Perfect for those who value simplicity and order, this design promotes both style and practicality, ensuring a serene cooking experience.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/907d78138216073.6218d6d342d13.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/907d78138216073.6218d6d342d13.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/f94d4a138216073.630c50ad169b5.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/8b7fca138216073.630c50ad1714c.jpg",
        },
        data: "20 January, 2025",
      },
      {
        id: 2,
        group: "Kitchen",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/fs/394ce7132532431.61aa9f5d7ad60.png",
        text: "A modern kitchen blending innovation with contemporary aesthetics.",
        description: `Cutting-edge appliances merge with sleek surfaces in this modern culinary space. The design encourages socializing while cooking, making it ideal for gatherings.
          <br /><br />
          Bold contrasts and glossy finishes create a vibrant, welcoming atmosphere, perfect for the modern lifestyle.`,
        link: "#",
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/394ce7132532431.61aa9f5d7ad60.png",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/0b9a12132532431.61aa9f5d79e68.png",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/01dd24132532431.61aa9f5d7a819.png",
        },
        data: "12 January, 2025",
      },
      {
        id: 3,
        group: "Kitchen",
        style: "Loft",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/086602194049427.65f73f2f55814.jpg",
        text: "An industrial loft kitchen with raw textures and open space.",
        link: "#",
        description: `Exposed brick, metal accents, and reclaimed wood define this loft-style kitchen. Its open layout seamlessly connects cooking and living areas.
          <br /><br />
          Ideal for creative spirits, it exudes an urban charm while maintaining everyday practicality.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/086602194049427.65f73f2f55814.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/3d33d0194049427.65f73f2f5396c.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/364cd4194049427.65f73f2f547c2.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/max_632/917510194049427.65f73f2ebe1d4.jpg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/max_632/692b35194049427.65f73f2ebf08f.jpg",
          photo_5:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a3d984194049427.65f73f2f52a69.jpg",
        },
        data: "05 January, 2025",
      },
      {
        id: 4,
        group: "Kitchen",
        style: "Provence",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/disp/2df35377189057.5c8454353d75b.jpg",
        text: "A charming Provence-style kitchen with rustic elegance.",
        link: "#",
        description: `Soft colors and vintage-inspired details make this kitchen warm and inviting. Natural wood surfaces add authenticity.
          <br /><br />
          The design captures the spirit of the French countryside while offering modern functionality.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/2df35377189057.5c8454353d75b.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/da94e477189057.5c845434ea351.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/b068ac77189057.5c845434ea025.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/f1c34177189057.5c8454353d112.jpg",
        },
        data: "25 December, 2025",
      },
      {
        id: 5,
        group: "Kitchen",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/fs/f02dcc207122587.66d8332e1f7dc.jpg",
        text: "A neoclassical kitchen that blends timeless design with modern needs.",
        link: "#",
        description: `Elegant molding and symmetrical layouts define this space, bringing a sense of grandeur to daily routines. Neutral tones and refined finishes set a classic tone.
          <br /><br />
          Its timeless look ensures it will never go out of style, while concealed storage keeps it functional.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/f02dcc207122587.66d8332e1f7dc.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/f6a2b0207122587.66d8332e1ff31.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/f4b2e4207122587.66d8332e20cfe.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/4cf01a207122587.66d8332e20634.jpg",
        },
        data: "28 January, 2025",
      },
      {
        id: 6,
        group: "Entrance Hall",
        style: "Minimalism",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/disp/62b567224991821.6814fe8431d9f.jpg",
        text: "A minimalist entrance hall with clean lines and thoughtful details.",
        link: "#",
        description: `A clutter-free design that welcomes you with open space and light. Neutral colors create an airy, peaceful mood.
          <br /><br />
          Built-in storage keeps the area organized, making it as practical as it is stylish.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/62b567224991821.6814fe8431d9f.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/1b0b1b224991821.6814fe84397f0.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/3a375f224991821.6814fe8431781.jpeg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/disp/d63e82224991821.6814fe84389bd.jpeg",
        },
        data: "10 February, 2025",
      },
      {
        id: 7,
        group: "Entrance Hall",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/5a92c6232848681.68a49233681a3.jpg",
        text: "A modern entrance hall that sets a striking first impression.",
        link: "#",
        description: `Bold accents and sleek finishes greet visitors with confidence. Lighting is strategically placed to highlight key features.
          <br /><br />
          This hall balances aesthetics and utility, creating a dynamic, inviting entryway.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5a92c6232848681.68a49233681a3.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/d0fc25232848681.68a492336897e.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/9d6d09232848681.68a49233690c4.jpg",
        },
        data: "18 February, 2025",
      },
      {
        id: 8,
        group: "Entrance Hall",
        style: "Loft",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/d8f226149079223.62e1081971402.jpg",
        text: "An industrial-style hall with character and charm.",
        link: "#",
        description: `Exposed brick walls and metal elements bring a raw, authentic feel. The space flows seamlessly into the main living area.
          <br /><br />
          It’s a welcoming space that showcases an urban personality right from the door.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/d8f226149079223.62e1081971402.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/7f40b1149079223.62e10819721ba.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/ec9b8f149079223.62e1081971aac.jpg",
        },
        data: "26 February, 2025",
      },
      {
        id: 9,
        group: "Entrance Hall",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/5405f2106496249.5f91221030a29.jpg",
        text: "A bright, modern entryway designed for elegance and ease.",
        link: "#",
        description: `Large mirrors and glossy surfaces make the area feel larger and lighter. Storage is hidden but easily accessible.
          <br /><br />
          The result is a functional, stylish transition into the home.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5405f2106496249.5f91221030a29.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/379b3a106496249.5f91221030fd3.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/638584106496249.5f9122103172d.jpg",
        },
        data: "06 March, 2025",
      },
      {
        id: 10,
        group: "Entrance Hall",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/736ea9232134905.6896075f21212.jpg",
        text: "A neoclassical entrance hall with timeless appeal.",
        link: "#",
        description: `Intricate detailing and symmetry bring an air of sophistication to the space. Soft lighting enhances the refined feel.
          <br /><br />
          Perfect for those who want a grand welcome that never goes out of fashion.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/736ea9232134905.6896075f21212.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/aa856b232134905.6896075f220e0.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/1f80ca232134905.6896075f21b07.jpg",
        },
        data: "14 March, 2025",
      },
      {
        id: 11,
        group: "Entrance Hall",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/b37212155273223.63513fd8f3437.jpg",
        text: "A grand entrance hall with subtle elegance.",
        link: "#",
        description: `Delicate architectural features add texture and interest. Warm hues make it inviting despite its formality.
          <br /><br />
          It’s an entryway that makes a lasting first impression.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/b37212155273223.63513fd8f3437.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/ba9f0a155273223.63513fd8f22a9.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs_webp/2f2d92155273223.63513fd9010cd.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/fs_webp/26130e155273223.63513fd900059.jpg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a4bcf2155273223.63513fd902007.jpg",
        },
        data: "21 March, 2025",
      },
      {
        id: 12,
        group: "Bathroom",
        style: "Minimalism",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/hd_webp/213de2231376011.6888540c9e921.png",
        text: "A minimalist bathroom focused on clarity and calm.",
        link: "#",
        description: `Simple forms and a restrained palette create a spa-like retreat. Natural light enhances the feeling of cleanliness.
          <br /><br />
          Every detail is chosen for function and beauty, removing all unnecessary clutter.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/hd_webp/213de2231376011.6888540c9e921.png",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/3c2894231376011.6888540c9db95.png",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/dd0a9f231376011.6888540c9e0a4.png",
        },
        data: "28 March, 2025",
      },
      {
        id: 13,
        group: "Bathroom",
        style: "Minimalism",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/4a4cec232427861.689c1cc1e0853.jpg",
        text: "A serene bathroom where less truly is more.",
        link: "#",
        description: `Neutral tones and open space promote relaxation. Fixtures are sleek and unobtrusive.
          <br /><br />
          It’s a place for unwinding, where simplicity takes center stage.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/4a4cec232427861.689c1cc1e0853.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/1750b7232427861.689c1cc1e177c.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/4fa523232427861.689c1cc1e1034.jpg",
        },
        data: "05 April, 2025",
      },
      {
        id: 14,
        group: "Bathroom",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/a33967198680643.6645020da0132.png",
        text: "A bold modern bathroom with stylish contrasts.",
        link: "#",
        description: `Dark and light surfaces play off each other for a striking effect. Innovative storage keeps essentials within reach.
          <br /><br />
          Designed for comfort and aesthetic impact, it’s a functional work of art.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a33967198680643.6645020da0132.png",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a33967198680643.6645020da0132.png",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/86b1e3198680643.6645020da095f.png",
        },
        data: "12 April, 2025",
      },
      {
        id: 15,
        group: "Bathroom",
        style: "Loft",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/f9aa63232498161.689d47fface75.jpg",
        text: "An industrial loft bathroom with urban flair.",
        link: "#",
        description: `Concrete textures and metal fixtures define this space. The design maximizes function without sacrificing style.
          <br /><br />
          Perfect for city living, it feels modern yet timeless.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/f9aa63232498161.689d47fface75.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/max_632/d8449b232498161.689d47ff32cc0.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/max_632/d80188232498161.689d47ff322b4.jpg",
        },
        data: "12 April, 2025",
      },
      {
        id: 16,
        group: "Bathroom",
        style: "Provence",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/72b77c53636213.593b1c8ab5dbc.jpg",
        text: "A charming Provence-inspired bathroom with vintage details.",
        link: "#",
        description: `Soft pastel colors and floral patterns infuse this bathroom with a romantic atmosphere. Wooden accents and classic fittings evoke the charm of the French countryside.
          <br /><br />
          The result is a warm, relaxing space that combines elegance with the comfort of a private retreat.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/72b77c53636213.593b1c8ab5dbc.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/09f22253636213.593b1c8ab6909.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/3d6a2953636213.593b1c8ab6daf.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/1d9b3e53636213.593b1c8ab607d.jpg",
        },
        data: "20 April, 2025",
      },
      {
        id: 17,
        group: "Bathroom",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/b79e27231147845.68838ad9f4229.jpg",
        text: "A neoclassical bathroom that exudes elegance and balance.",
        link: "#",
        description: `Symmetry and decorative molding give this bathroom a timeless appeal. Light marble surfaces add a touch of luxury without overwhelming the senses.
          <br /><br />
          A calm and refined atmosphere makes it an ideal place to start and end the day in style.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/b79e27231147845.68838ad9f4229.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/996221231147845.68838ada01021.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/29af3a231147845.68838ada0076c.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/95e384231147845.68838ada016d4.jpg",
        },
        data: "27 April, 2025",
      },
      {
        id: 18,
        group: "Bathroom",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/93d9c2168489205.643bb087f0e76.jpg",
        text: "A neoclassical bathroom that exudes elegance and balance.",
        link: "#",
        description: `Symmetry and decorative molding give this bathroom a timeless appeal. Light marble surfaces add a touch of luxury without overwhelming the senses.
          <br /><br />
          A calm and refined atmosphere makes it an ideal place to start and end the day in style.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/93d9c2168489205.643bb087f0e76.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/399f39168489205.643bb087ef8b5.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5d65bb168489205.643bb087f0358.jpg",
        },
        data: "05 May, 2025",
      },
      {
        id: 19,
        group: "Living room",
        style: "Minimalism",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/1b5a37156201575.6362be118c43b.jpg",
        text: "A minimalist living room with open space and serene tones.",
        link: "#",
        description: `Clean lines and uncluttered surfaces create a calm, airy living environment. Natural light flows freely through the space.
          <br /><br />
          The design focuses on essential pieces, making each one stand out while maintaining overall harmony.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/1b5a37156201575.6362be118c43b.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/c4dd86156201575.6362be1189c1f.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/max_632_webp/d606cc156201575.6362be118b34a.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a92717156201575.6362be11879d4.jpg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5fe1d3156201575.6362be118a7a7.jpg",
          photo_5:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/1964a2156201575.6362be1188df5.jpg",
        },
        data: "12 May, 2025",
      },
      {
        id: 20,
        group: "Living room",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/4e4333220184677.67beb3a59f813.jpg",
        text: "A modern living room with bold accents and sleek comfort.",
        link: "#",
        description: `Geometric shapes and contrasting textures define this contemporary space. Statement furniture pieces make it stylish yet functional.
          <br /><br />
          Perfect for entertaining or relaxing, it strikes a balance between sophistication and coziness.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/4e4333220184677.67beb3a59f813.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/93fd3c220184677.67beb3a59e86d.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/8e4ddd220184677.67beb3a59f08d.png",
        },
        data: "19 May, 2025",
      },
      {
        id: 21,
        group: "Living room",
        style: "Modern",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/141fe5222173249.67e184a6886bf.jpg",
        text: "A modern lounge blending neutral tones with luxurious finishes.",
        link: "#",
        description: `Neutral colors set the tone for comfort, while metallic details add a hint of glamour. The layout encourages conversation and relaxation.
          <br /><br />
          This space exemplifies how minimal ornamentation can still feel rich and inviting.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/141fe5222173249.67e184a6886bf.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/69338a222173249.67e184a686b94.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/4939ea222173249.67e184a6874ea.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/2928fd222173249.67e184a687db5.jpg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/9a1e69222173249.67e184a689169.jpg",
        },
        data: "27 May, 2025",
      },
      {
        id: 22,
        group: "Living room",
        style: "Loft",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/3b8ee2173365085.648f45485cedd.jpg",
        text: "An industrial loft living room with a creative edge.",
        link: "#",
        description: `Exposed beams, brick walls, and tall windows make this space light-filled and full of character. Neutral furnishings balance the bold architecture.
          <br /><br />
          A perfect setting for both quiet evenings and lively gatherings.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/3b8ee2173365085.648f45485cedd.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/89a7b5173365085.648f45485bfbc.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/2c744b173365085.648f45485df5a.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/a8966c173365085.648f45485ed33.jpg",
        },
        data: "04 June, 2025",
      },
      {
        id: 23,
        group: "Living room",
        style: "Provence",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/30844e50108589.58c7bca006be5.jpg",
        text: "A Provence-style living room with rustic elegance.",
        link: "#",
        description: `Light fabrics, distressed wood, and floral motifs bring a gentle, rural charm. Sunlight enhances the warm, welcoming atmosphere.
          <br /><br />
          It’s a space designed for comfort, conversation, and lingering over coffee.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/30844e50108589.58c7bca006be5.jpg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/f875d350108589.58c7bca0064e5.jpg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/6743fa50108589.58c7bca007fe6.jpg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5060f050108589.58c7bca005a61.jpg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/812a8850108589.58c7bca008563.jpg",
          photo_5:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/5fcf0a50108589.58c7bca005f5d.jpg",
          photo_6:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/b754e150108589.58c7bca007b56.jpg",
          photo_7:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/698b2e50108589.58c7bca0071a9.jpg",
        },
        data: "12 June, 2025",
      },
      {
        id: 24,
        group: "Living room",
        style: "Neoclassic",
        photo:
          "https://mir-s3-cdn-cf.behance.net/project_modules/source/36335c173908817.6498a0f7b538a.jpeg",
        text: "A refined neoclassical living room with a timeless look.",
        link: "#",
        description: `High ceilings and detailed molding create an atmosphere of grandeur. Plush seating ensures the space is as comfortable as it is beautiful.
          <br /><br />
          This room offers a perfect blend of traditional design and modern livability.`,
        slider: {
          photo_0:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/36335c173908817.6498a0f7b538a.jpeg",
          photo_1:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/fd56bc173908817.6498a0f7b033c.jpeg",
          photo_2:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/3d81cd173908817.6498a0f7b6edc.jpeg",
          photo_3:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/34d4e7173908817.6498a0f7b1b4e.jpeg",
          photo_4:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/e08aef173908817.6498a0f7aeb5d.jpeg",
          photo_5:
            "https://mir-s3-cdn-cf.behance.net/project_modules/source/b0ca8a173908817.6498a0f7b317d.jpeg",
        },
        data: "20 June, 2025",
      },
    ],
  },
  getters: {
    indexPageCards:
      (state) =>
      (...indexes) => {
        return state.designCards.filter((_, index) => indexes.includes(index));
      },
    getDesignCards(state) {
      return state.designCards;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
